module.exports = __webpack_public_path__ + "img/68.65430bd8.png";